export default __webpack_public_path__ + "static/img-project-9-88bed5db7d776548c6f89c35d114129c.png";